import { useState, useEffect, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { showSnackbar } from '@global/snackbar/snackbar.actions'
import { api } from 'api'
import { EditTemplateContext } from '../../../../edit-template-context'

interface TemplateState {
  Template: {
    template: {
      id: string
      [key: string]: any
    }
  }
}

export function useFetchTemplateApprovers(cb: (values: []) => void, requireApproval: boolean) {
  const dispatch = useDispatch()
  const { requestCache = {} } = useContext(EditTemplateContext)
  const template = useSelector((state: TemplateState) => state.Template.template)
  const [loadingSavedApprovers, setLoadingSavedApprovers] = useState(false)

  useEffect(() => {
    if (!requireApproval) return

    const url = `/api/v1/account/approvers/${template.id}`

    const fetchApprovers = async () => {
      try {
        const { data } = await api.get(url)
        requestCache[url] = data
        cb(data)
        setLoadingSavedApprovers(false)
      } catch {
        setLoadingSavedApprovers(false)
        dispatch(
          showSnackbar({
            type: 'ERROR',
            duration: 5000,
            message: 'Failed to load approvers',
          }),
        )
      }
    }

    if (template.id && !requestCache[url]) {
      setLoadingSavedApprovers(true)
      void fetchApprovers()
    }
  }, [template.id])

  return loadingSavedApprovers
}
